<template>
  <div>
    <h1 class="logintitle">
      <img src="@/assets/login/images/kunlun_logo.png">
    </h1>
    <div class="loginbox">
      <div v-if="showQrLogin" class="qrlogin">
        <span>钉钉扫码登录</span>
        <dd-login
          :appid="dingLoginAppId"
          :login-url="dingLoginUrl"
          :width="365"
          :height="320"
          inner-style="border:none;background-color:transparent"
        />
        <a @click="showQrLogin = false" style="cursor:pointer">管理员登录</a>
      </div>
      <form v-show="!showQrLogin" method="post" @submit.stop.prevent="submit">
        <ul>
          <li class="input-icon">
            <input v-model.trim="username" @input="clearErrMsg" name="username" autocomplete="off" type="text" placeholder="请输入用户名">
            <span v-show="invalidUsername">{{ errorMsg }}</span>
          </li>
          <li class="input-icon icon-pwd">
            <input v-model.trim="password" @input="clearErrMsg" name="password" autocomplete="off" type="password" placeholder="请输入密码">
            <span v-show="invalidPassword">您输入的密码有误</span>
          </li>
          <li>
            <button class="login-btn" type="submit">登录</button>
          </li>
          <li>
            <a class="clear-link" @click="clearStorage">清空本地缓存</a>
          </li>
        </ul>
        <a v-show="this.$route.hash === '#dingtalk'" @click="showQrLogin = true" style="color:#FFF;cursor:pointer">钉钉扫码登录</a>
      </form>
    </div>
    <div class="loginbm">
      <h4>Kunlun Data Information Platform</h4>
      <p>昆仑数据信息平台 fib.jiemo.net Copyright © 2016-{{ year }} Kunlun. ALL Rights Reserved.</p>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import lockr from 'lockr';
import DingQrLogin from '@/components/dingQrLogin';

const dingLoginAppId = 'dingl7q06ziowxzeqvl5';

export default {
  name: 'Login',
  data() {
    return {
      dingLoginAppId,
      showQrLogin: this.$route.hash === '#dingtalk',
      invalidUsername: false,
      invalidPassword: false,
      username: '',
      password: '',
      errorMsg: '请输入用户名'
    };
  },
  components: {
    'dd-login': DingQrLogin
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    },
    dingLoginUrl() {
      let baseUrl = 'https://fib.jiemo.net'; // 正式服地址
      if (!this.$isOnline) {
        baseUrl = 'https://fib.dev.jiemo.net'; // 非正式服，包含本地开发
      }
      return `${baseUrl}/frontend/dingLogin`;
    }
  },
  methods: {
    clearStorage() {
      this.$message.success(`已经清理本地缓存${localStorage.length}条`);
      lockr.flush();
      localStorage.clear();
    },
    clearErrMsg() {
      this.invalidUsername = false;
    },
    submit() {
      if (!this.username) {
        this.invalidUsername = true;
        return false;
      }
      _post({
        url: '/index/login/index',
        data: {
          username: this.username,
          password: this.password
        }
      }).then((res) => {
        if (res.code > 0) {
          this.errorMsg = res.msg;
          this.invalidUsername = true;
          return false;
        }
        lockr.set('jwt', res.data);
        window.location.href = res.url;

        // 暂停登录旧系统
        // _post({
        //   url: '/system.php/Login/index',
        //   data: {
        //     email: this.username,
        //     pwd: this.password,
        //     myip: '',
        //   }
        // }).then(({ url }) => {
        //   console.warn(`新旧版蓝火系统同步登录首页：${res.url} | ${url}`);
        //   // 修复本地调试：当切换正式库时，旧系统无法返回数据的情况（本地旧系统始终为测试库）
        //   if (!url || url === undefined) {
        //     url = res.url;
        //   }
        //   window.location.href = url;
        // });
      });
      return false;
    },
  },
  mounted() {
  },
  created() {
    if (this.$route.query.code) {
      this.$alert(this.$route.query.code);
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
    lockr.flush();
  }
};
</script>
<style>
body {
  height: 100%;
  background-color: #E9D5CB;
  background-image: url('../assets/login/images/kunlun_loginbg.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
}
#app {
  padding-top: 130px;
}
</style>
<style scoped>
h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
input {
  border: none;
  background: none;
  width: 320px;
  height: 45px;
  border: none;
  line-height: 45px;
  border-radius: 22.5px;
  font-size: 14px;
  padding:0 25px;
  outline: none;
  border: 1px solid #fff;
  background: rgba(255,255,255,.62);
  color: #616161;
  font-family: "微软雅黑", Microsoft Yahei;
  transition: all linear 0.2s;
}
input:-internal-autofill-selected {
  /*内置阴影填充 背景颜色*/
  box-shadow: inset 0 0 0 1000px rgba(255,255,255,.62) !important;
  /*只有谷歌兼容 字体颜色*/
  -webkit-text-fill-color: #616161 !important;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 400px rgba(255,255,255,.62) inset;
  -webkit-text-fill-color: #616161;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 99999s;
  -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
}
input:focus{
  box-shadow: 0 0 10px rgba(255,255,255,.6);
}
.qrlogin{
  background: #ffffffef;
  display: block;
  width: 400px;
  padding: 20px 0;
  margin: 0 auto;
  border-radius: 15px
}
.clear-link {
  display: block;
  padding: 10px;
  color:#ffffffcc;
  cursor: pointer;
  font-size:13px;
}
.login-btn {
  background-color: #FFF;
  cursor: pointer;
  color: #333;
  height: 45px;
  width: 320px;
  border: none;
  border-radius: 45px;
  margin-top: 40px;
  font-size: 16px;
  transition: all linear 0.2s;
}
.login-btn:hover{
  box-shadow: 0 0 10px rgba(255,255,255,.6);
}
.logintitle {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite;
}
.logintitle2 {
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 200;
  padding: 70px 0;
}
.loginbox {
  width: auto;
  height: 336px;
  margin: auto;
  text-align: center;
  animation: loginmove 1s ease-out 1;
}
.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 12px 0;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  bottom: 12px;
  display: block;
  width: 211px;
  height: 45px;
  text-align: center;
  line-height: 45px;
  background-color: #fcd71d;
  font-size: 14px;
  color: #383838;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
  margin-top: -10px;
}
.loginbm {
  line-height: 23px;
  margin-top: 120px;
  text-align: center;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}
.loginbm a {
  font-weight: bold;
  color: #fff;
}
.loginbm a:hover {
  color: #fff;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #fff;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}
</style>
